import React, { useState } from "react";
import { Link } from "react-router-dom";
import LoanForm from "../../components/Forms/LoanForm";
import CardForm from "../../components/Forms/CardForm";
import ContactForm from "../../components/Forms/ContactForm";
import "./LandingPage.css";

const LandingPage = () => {
  const [activeTab, setActiveTab] = useState("loan");

  return (
    <div className="landing-page">
      <nav className="navbar">
        <div className="nav-container">
          <h1 className="nav-logo">MercadoPrestamos</h1>
          <Link to="/login" className="nav-login">Portal Administrativo</Link>
        </div>
      </nav>

      <section className="hero">
        <div className="hero-content">
          <h1>Tu Mercado de Préstamos Online</h1>
          <p>Acceso a múltiples opciones de crédito con los mejores términos y tasas</p>
          <button onClick={() => document.querySelector(".forms-section").scrollIntoView({ behavior: "smooth" })} className="btn-cta">
            Solicitar Préstamo
          </button>
        </div>
      </section>

      <section className="features">
        <h2>¿Por qué elegirnos?</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">&#9889;</div>
            <h3>Rápido y Fácil</h3>
            <p>Solicita tu préstamo en minutos con nuestro formulario simple</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">&#127974;</div>
            <h3>Múltiples Opciones</h3>
            <p>Acceso a varias instituciones financieras y sus productos</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">&#128274;</div>
            <h3>Seguro y Confiable</h3>
            <p>Tus datos están protegidos con encriptación de nivel bancario</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">&#128172;</div>
            <h3>Soporte 24/7</h3>
            <p>Atención al cliente disponible en todo momento</p>
          </div>
        </div>
      </section>

      <section className="forms-section">
        <h2>Comience aquí</h2>
        <div className="forms-tabs">
          <button className={`tab-btn ${activeTab === "loan" ? "active" : ""}`} onClick={() => setActiveTab("loan")}>Solicitar Préstamo</button>
          <button className={`tab-btn ${activeTab === "card" ? "active" : ""}`} onClick={() => setActiveTab("card")}>Solicitar Tarjeta</button>
          <button className={`tab-btn ${activeTab === "contact" ? "active" : ""}`} onClick={() => setActiveTab("contact")}>Contáctenos</button>
        </div>
        <div className="forms-container">
          {activeTab === "loan" && <LoanForm />}
          {activeTab === "card" && <CardForm />}
          {activeTab === "contact" && <ContactForm />}
        </div>
      </section>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h4>MercadoPrestamos</h4>
            <p>Tu solución de crédito en un solo lugar</p>
          </div>
          <div className="footer-section">
            <h4>Enlaces</h4>
            <ul><li><a href="#inicio">Inicio</a></li><li><a href="#servicios">Servicios</a></li></ul>
          </div>
          <div className="footer-section">
            <h4>Legal</h4>
            <ul><li><a href="#privacidad">Privacidad</a></li><li><a href="#terminos">Términos</a></li></ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 MercadoPrestamos. Todos los derechos reservados.</p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
